module.exports = __webpack_public_path__ + "img/v2.0.676fd9f7.png";